
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import { UserSettingsContext } from "contexts/UserSettingsContext";
import { useContext } from "react";



export const ICON_MAPPING = {
    street: "🛣️",
    city: "🏙️",
    dice: "🎲",
    state: "🗺️",
    botname: "👤", avatarEnabled: "👤", dIdFullBody: "👤", person: "👤",
    icon: "🧩",
    role: "👔",
    goal: "🎯", target: "🎯",
    tone: "🔊",
    input: "🖋️",
    file: "🗂️",
    maxlength: "📏",
    temperature: "🌡️", analytics_temperature: "🌡️",
    model: "🚀", "ai-model": "🚀",
    target_percentage: "🔢",
    label: "🏷️", target_fields: "🏷️", tags: "🏷️", assistant_name: "🏷️",
    target_prompt: "📝", create_dossier: "📝", description: "📝", descriptionPen: "📝",
    set_for_test: "🔍", analysis: "🔍",
    test_history: "📜", description_history: "📜",
    task: "📋", Text: "📋", Website: "📋",
    create_customer: "👥", people: "👥",
    condition_field: "❓",
    condition_value: "🔢", id: "🔢",
    api: "📡",
    accesscontrol: "🔒",
    author: "✍️", signature: "✍️",
    calltoaction: "📢",
    contentid: "🆔",
    link: "🔗",
    thumbnailimage: "🖼️",
    title: "📌",
    topic: "📂", type: "📁",
    views: "👁️",
    video: "📹",
    visibility: "👓",
    date: "📅", created_at: "📅",
    due_date: "⏳",
    headline: "🏷️", avatarName: "🏷️", source_section: "🏷️", label: "🏷️",
    is_done: "✔️",
    is_verified: "✅", active: "✅", target_type: "✅",
    conversationHeadline: "💬", conversationSubline: "💬", conversationOpeningText: "💬", saveConversationQuestion: "💬", Yes: "💬", No: "💬",
    text: "💬", analytics_text: "💬", comment: "💬",
    dIdKey: "🔑", stage_key: "🔑", key: "🔑",
    avatarImage: "📸",
    companyLogo: "🏢",office: "🏢",
    avatarHeight: "↕️",
    notesEnabled: "📓",
    dIdVoiceID: "📣", subject: "📣",
    seed: "🌱",
    is_assistant_talking: "🗣️", 
    avatarWidth: "↔️", direction: "↔️",
    avatarHeight: "↕️", list_page_length:"↕️",
    keywords:"🎯",
    prompt:"📝", content: "📝",
    source: "🔗",
    email: "📧",
    responsible: "👤",
    password: "🔑",
    authentication: "🔒",
    imap: "📥", default_account_settings: "📥",
    smtp: "📤", 
    folder: "📁",
    default: "🌟", priority: "🌟",
    check_spam: "🛡️",
    spam_threshold: "⚖️",
    object_type:"🔖", 
    single_select: "🔘",
    phone: "📞",
    assistant_languageanswer_email: "🌍", globe: "🌍",
    gear: "⚙️",
    Joystick: "🕹️",
    is_profile_visible: "👤",
    is_dashboard_visible: "📊",
    is_chat_sessions_visible: "💬",
    is_emails_visible: "📧",
    is_customers_visible: "👥",
    is_ai_control_visible: "🤖",
    is_knowledge_visible: "📚",
    show_icons: "👋",
    is_assistant_talking: "🗣️",
    is_todos_visible: "✅",
    is_notes_visible: "📝",
    is_orders_visible: "🛒",
    is_settings_visible: "⚙️",              // Settings icon
    is_uploads_visible: "📤",               // Uploads icon
    is_companies_visible: "🏢",             // Companies icon
    is_products_visible: "📦",              // Products icon (box representing goods/products)
    is_contracts_visible: "📑",             // Contracts icon (document or page)
    is_events_visible: "📅",                // Events icon (calendar for events or dates)
    is_message_templates_visible: "📝",     // Message templates icon (note or edit icon)c   
    is_communication_plans_visible: "📢",    
    analyze_all_contacts: "🔍",    
    auto_send_after_talking: "📲",          // Auto-send icon (mobile or conversation icon)
    order: "📦",
    update: "🔄",
    tools: "🛠️",
    fileCabinet: "🗄️",
    womanTechnologiest: "👩‍💻",
    moneyBag: "💰",
    money: "💵",
    tax: "💸",
    status: "🚥",
    clock: "🕒", 
    address: "📬",
    save: "💾",
    deleted: "🗑️",
    sent: "✉️",
    happy: "😊",
    wavingHand: "👋",
    suit: "👔",
    working: "🧑‍💻",
    website: "🌐",
    industry: "🏭",
    birthday: "🎂",
    sunrise: "🌅",
    sunset: "🌇",
    time: "⏰",
    stopwatch: "⏱️",
    redTriangle: "🔺",
    palette: "🎨",
    loveletter: "💌",
    envelopeWithBox: "📨",
    bell: "🔔",
    microscop: "🔬",
    exclude: "🚫",
    restrict: "⛔",
    job: "💼",
    compass: "🧭",
    flask: "⚗️"
};

const IconButton = ({ translationId, icon }) => {
    const { userSettings, updateSetting } = useContext(UserSettingsContext);
    const toggleIcons = () => {
        updateSetting('show_icons', !userSettings.show_icons)
    }

    return <IconButtonWithTooltip translationId={translationId} icon={ICON_MAPPING[icon]} onClick={toggleIcons} type='IconButton'/>
}

export default IconButton;
